import { clockLabel, hoursLabel } from "./scheduleFormatters";

const MONTH_DAY = { month: "short", day: "numeric", timeZone: "UTC" };

const utcDate = (isoDate) => new Date(`${isoDate.slice(0, 10)}T00:00:00Z`);

export const periodLabel = (startsOn, endsOn) => {
  const start = utcDate(startsOn);
  const end = utcDate(endsOn);
  const year = end.getUTCFullYear();
  const startLabel = start.toLocaleDateString("en-US", MONTH_DAY);
  const endLabel =
    start.getUTCMonth() === end.getUTCMonth()
      ? String(end.getUTCDate())
      : end.toLocaleDateString("en-US", MONTH_DAY);
  return `${startLabel} – ${endLabel}, ${year}`;
};

export const cardDateLabel = (localTime) =>
  utcDate(localTime).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });

export const localClockLabel = (localTime) =>
  localTime ? clockLabel(localTime.slice(11, 16)) : "";

export const rangeLabel = (startsAt, endsAt) =>
  endsAt
    ? `${localClockLabel(startsAt)}–${localClockLabel(endsAt)}`
    : `${localClockLabel(startsAt)}–now`;

export const hoursOrDash = (minutes) => (minutes ? hoursLabel(minutes) : "—");

const minutesBetween = (startsAt, endsAt) =>
  (new Date(`${endsAt}:00Z`) - new Date(`${startsAt}:00Z`)) / 60000;

export const takenBreakMinutes = (breaks) =>
  breaks
    .filter(
      (timeCardBreak) =>
        timeCardBreak.status === "taken" && timeCardBreak.endedAt,
    )
    .reduce(
      (total, timeCardBreak) =>
        total + minutesBetween(timeCardBreak.startedAt, timeCardBreak.endedAt),
      0,
    );

export const FLAG_BADGES = {
  late: { label: "Late", color: "warning" },
  early_override: { label: "Early clock-in", color: "warning" },
  unscheduled: { label: "Unscheduled", color: "gray" },
  auto_clocked_out: { label: "Auto clock-out", color: "error" },
  missed_break: { label: "Missed break", color: "error" },
  outside_geofence: { label: "Outside geofence", color: "warning" },
  correction_requested: { label: "Correction requested", color: "brand" },
  sent_back: { label: "Sent back by lead", color: "brand" },
  edited_by_lead: { label: "Edited by lead", color: "warning" },
  offline: { label: "Offline punch", color: "gray" },
};

export const STATUS_BADGES = {
  open: { label: "Clocked in", color: "brand" },
  pending: { label: "Pending", color: "gray" },
  approved: { label: "Approved", color: "success" },
};

export const PERIOD_BADGES = {
  open: { label: "Open", color: "brand" },
  locked: { label: "Locked", color: "gray" },
  exported: { label: "Exported", color: "success" },
};
